module.exports = __webpack_public_path__ + "img/nuxtjs-logo.51131d31.svg";